/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandDcos = createReactComponent("brand-dcos", "IconBrandDcos", [
  ["path", { d: "M3 18l18 -12h-18l9 14l9 -14v10l-18 -10z", key: "svg-0" }]
]);

export { IconBrandDcos as default };
//# sourceMappingURL=IconBrandDcos.js.map
